// extracted by mini-css-extract-plugin
module.exports = {"table":"AdminOperatorListManagement_table__2XA9x"};